import { SemesterCourseConfig, SemesterConfig, OverallMarkSheet } from '@/plugins/api'
import { upsertMany } from '@/helpers'
import { differenceBy, uniqBy } from 'lodash'
import { MarkSheetRow } from '../../plugins/api'
export default {
  namespaced: true,
  state: {
    overallMarkSheets: [],
    semesterConfigs: [],
    semesterCourseConfigs: [],
    isLoadingMarkSheets: false,
    markSheetContents: [],
    markSheetRows: []
  },
  actions: {
    async fetchOverallMarkSheets({ commit }) {
      try {
        commit('setIsLoadingMarkSheets', true)
        const overallMarkSheets = await OverallMarkSheet.fetch()
        commit('setOverallMarkSheets', overallMarkSheets)
      } catch (error) {
        throw error
      } finally {
        commit('setIsLoadingMarkSheets', false)
      }
    },
    async fetchMarkSheetRows({ commit }) {
      const res = await MarkSheetRow.fetch()
      commit('setMarkSheetRows', res)
    },
    async fetchOverallMarkSheet({ commit, state }, { marksheetId }) {
      const res = await OverallMarkSheet.fetchOne(marksheetId)

      commit('setOverallMarkSheets', upsertMany(state.overallMarkSheets, res))
    },
    async fetchOverallMarkSheetContent({ commit, state }, { marksheetId }) {
      const res = await OverallMarkSheet.fetchContent(marksheetId)
      commit('setOverallMarkSheetContents', upsertMany(state.markSheetContents, res))
    },
    async fetchSemesterConfigs({ commit }, { marksheetId }) {
      const semesterConfigs = await SemesterConfig.fetch({ overall_mark_sheet: marksheetId })
      commit('setSemesterConfigs', semesterConfigs)
    },
    async fetchSemesterCourseConfigs({ commit, state }, { semesterId }) {
      const v = await SemesterCourseConfig.fetch({
        semester_config: semesterId
      })
      commit('setSemesterCourseConfigs', upsertMany(state.semesterCourseConfigs, v))
    },
    async createOverallMarkSheet({ commit, state }, { data }) {
      const v = await OverallMarkSheet.create(data)
      commit('setOverallMarkSheets', [v, ...state.overallMarkSheets])
    },
    async createMarkSheetRow({ commit, state }, { data }) {
      const v = await MarkSheetRow.create(data)
      commit('setMarkSheetRows', [...state.markSheetRows, v])
    },
    async createSemesterConfig({ commit, state }, { data }) {
      const v = await SemesterConfig.create(data)
      commit('setSemesterConfigs', [...state.semesterConfigs, v])
    },
    async createSemesterCourseConfig({ commit, state }, { data }) {
      const v = await SemesterCourseConfig.create(data)
      commit('setSemesterCourseConfigs', [...state.semesterCourseConfigs, v])
    },
    async updateOverallMarkSheet({ commit, state }, { id, ...data }) {
      const v = await OverallMarkSheet.update(id, data)
      commit('setOverallMarkSheets', upsertMany(state.overallMarkSheets, v))
    },
    async updateMarkSheetRow({ commit, state }, { id, ...data }) {
      const v = await MarkSheetRow.update(id, data)
      commit('setMarkSheetRows', upsertMany(state.markSheetRows, v))
    },
    async updateSemesterConfig({ commit, state }, { id, ...data }) {
      const v = await SemesterConfig.update(id, data)
      commit('setSemesterConfigs', upsertMany(state.semesterConfigs, v))
    },
    async updateSemesterCourseConfig({ commit, state }, { id, ...data }) {
      const v = await SemesterCourseConfig.update(id, data)
      commit('setSemesterCourseConfigs', upsertMany(state.semesterCourseConfigs, v))
    },
    async removeOverallMarkSheet({ commit, state }, id) {
      commit(
        'setOverallMarkSheets',
        state.overallMarkSheets.filter(i => i.id !== id)
      )
      await OverallMarkSheet.remove(id)
    },
    async removeMarkSheetRow({ commit, state }, id) {
      commit(
        'setMarkSheetRows',
        state.markSheetRows.filter(i => i.id !== id)
      )
      await MarkSheetRow.remove(id)
    },
    async removeSemesterConfig({ commit, state }, id) {
      commit(
        'setSemesterConfigs',
        state.semesterConfigs.filter(i => i.id !== id)
      )
      await SemesterConfig.remove(id)
    },
    async removeSemesterCourseConfig({ commit, state }, id) {
      commit(
        'setSemesterCourseConfigs',
        state.semesterCourseConfigs.filter(i => i.id !== id)
      )
      await SemesterCourseConfig.remove(id)
    }
  },
  mutations: {
    setOverallMarkSheets(state, v) {
      state.overallMarkSheets = v
    },
    setMarkSheetRows(state, v) {
      state.markSheetRows = v
    },
    setOverallMarkSheetContents(state, v) {
      state.markSheetContents = v
    },
    setSemesterConfigs(state, v) {
      state.semesterConfigs = v
    },
    setSemesterCourseConfigs(state, v) {
      state.semesterCourseConfigs = v
    },
    setIsLoadingMarkSheets(state, v) {
      state.isLoadingMarkSheets = v
    }
  }
}
